import { render, staticRenderFns } from "./CreateBannerItem.vue?vue&type=template&id=46ed3f17&scoped=true"
import script from "./CreateBannerItem.vue?vue&type=script&lang=ts"
export * from "./CreateBannerItem.vue?vue&type=script&lang=ts"
import style0 from "./CreateBannerItem.vue?vue&type=style&index=0&id=46ed3f17&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ed3f17",
  null
  
)

export default component.exports